<script setup lang="ts">
// Standings-tab substitute for individual sports. Grouped: tennis is one group
// (e.g. "WTA"), MMA is one group per division (pound-for-pound + weight classes).
// Rows link to Player pages.
interface Rank {
  provider_player_id: string; rank: number; name: string
  points?: string; trend?: string; country?: string; flag?: string; record?: string
}
interface Group { name: string; ranks: Rank[] }
const props = defineProps<{ rankings: Group[]; league: string }>()
const single = computed(() => (props.rankings?.length || 0) === 1)
function playerLink(r: Rank) {
  return `/scoreboard/player/${encodeURIComponent(r.provider_player_id)}?league=${encodeURIComponent(props.league)}`
}
</script>

<template>
  <div class="rankings">
    <div v-if="rankings && rankings.length">
      <div v-for="g in rankings" :key="g.name" class="group">
        <h3 v-if="!single" class="grp">{{ g.name }}</h3>
        <div class="list">
          <NuxtLink v-for="r in g.ranks" :key="r.provider_player_id || r.rank"
            :to="playerLink(r)" class="row">
            <span class="rk mono">{{ r.rank }}</span>
            <img v-if="r.flag" :src="r.flag" class="flag" alt="" loading="lazy" />
            <span class="nm">{{ r.name }}</span>
            <span v-if="r.record" class="rec mono">{{ r.record }}</span>
            <span v-if="r.points" class="pts mono">{{ r.points }}</span>
          </NuxtLink>
        </div>
      </div>
    </div>
    <p v-else class="empty">Rankings aren't available for this competition yet.</p>
  </div>
</template>

<style scoped>
.group { margin-bottom: 20px; }
.grp { font-size: 13px; font-weight: 800; margin-bottom: 9px; color: var(--ink); }
.list { border: 1px solid var(--line); border-radius: 12px; background: var(--panel); overflow: hidden; }
.row { display: flex; align-items: center; gap: 11px; padding: 10px 14px;
  border-bottom: 1px solid rgba(53,42,96,0.5); }
.row:last-child { border-bottom: none; }
.row:hover { background: rgba(34,26,73,0.55); }
.rk { width: 26px; text-align: right; color: var(--muted); }
.flag { width: 20px; height: 14px; object-fit: cover; border-radius: 2px; }
.nm { font-weight: 600; flex: 1; }
.row:hover .nm { color: var(--accent); }
.rec { color: var(--muted); font-size: 12px; }
.pts { color: var(--ink); font-size: 12px; font-weight: 700; min-width: 48px; text-align: right; }
.empty { color: var(--muted); text-align: center; padding: 24px 16px; }
</style>
